import {validatePixel} from 'privates/validations/styleValidation';
import styleService from './styleService';
import * as members from 'privates/privateMembers';
import {StyleProperties} from 'privates/styleConstants';
/*
 * @mixin BorderWidthMixin
 * @summary Provides functionality for changing an element's border width.
 *
 * @memberof $w.Style
 */
class BorderWidthMixin {
    /**
     * @ignore
     */
    set borderWidth(width) {
        const compNickname = members._compNickname.get(this);

        const isValid = validatePixel(width, StyleProperties.BORDER_WIDTH, compNickname, 'width');
        if (!isValid){
            return;
        }
        styleService.setStyle.call(this, StyleProperties.BORDER_WIDTH, width);
    }

    /**
     * @member borderWidth
     * @label property
     * @syntax
     * get borderWidth(): string
     * set borderWidth(width: string): void
     * @summary Sets or gets the border width of an element.
     * @description
     *  The border width value is a string representing the element's border
     *  width in pixels. For example, `"1px"`.
     * @snippet [BorderMixin-borderWidth_set.es6=Set the border width]
     * @snippet [BorderMixin-borderWidth_get.es6=Get the border width]
     * @type {external:String}
     * @memberof $w.Style
     * @instance
     */
    get borderWidth() {
        return styleService.getStyleParamValue.call(this, StyleProperties.BORDER_WIDTH);
    }
}

export default BorderWidthMixin;



// WEBPACK FOOTER //
// ./js/modules/ui/mixins/styleMixins/BorderWidthMixin.es6